// @flow
import $ from 'jquery';
import JQueryView, { on } from '../../common/JQueryView';
import Confettiful from '../../common/Confettiful';
import ahoy from 'ahoy.js';

export default class IndexView extends JQueryView {
  showGrowthStageModal: boolean;

  constructor(showGrowthStageModal: boolean) {
    super('.show');
    let length = $('.task:input:checkbox:checked').length;
    $('.finished-step').text(length);
    if (length == 0) {
      $('.indicator').addClass('text-gray');
    }
    this.render();
    if (showGrowthStageModal) {
      $('.show-growth-stage-modal').click();
    }
  }

  confetti_perform = () => {
    $('.task-steps-panel .card-body').hide();
    $('.step-finished').show();
    window.confettiful = new Confettiful(
      document.querySelector('.task-steps-panel'),
    );
    new Promise(resolve => {
      //全タスク達成済み10秒演出を表示する
      setTimeout(() => {
        //無事演出が終わったことを伝える
        resolve();
      }, 10000);
    }).then(() => {
      $('.task-steps-panel').hide(1000);
      // 演出が無事終わったことを受けとって実行される処理
      $.ajax({
        url: '/company/home/set_confetti_performed',
        dataType: 'script',
        type: 'put',
      });
    });
  };

  @on({ event: 'click', selector: 'div.banner' })
  clickBannerLink(e: any) {
    window.open(
      $(e.currentTarget)
        .find('a.link')
        .attr('href'),
      '_blank',
    );
  }

  @on({ event: 'click', selector: 'div.ahoy-tracked' })
  clickBannerTracked() {
    ahoy.track('fundoor_seminar_banner_clicked', {
      seminar_url: $('div.banner a.link').attr('href'),
    });
  }

  @on({ event: 'click', selector: '.q-and-a' })
  clickQandA() {
    const firstTimeLauncherElement = $('.intercom-launcher');

    // NOTE:
    // いったんIntercomManagerを開くと以下のような動作になる
    // - 元から存在した .intercom-launcher 要素(IntercomManager Open用のアイコン)は無くなる
    // - 新しく iframe内に .intercom-launcher 要素 が作成される
    //
    // そのため.intercom-launcher が存在しない場合には、
    // iframe内に存在することを前提として要素を取得し直す処理を行う
    if (firstTimeLauncherElement.length) {
      firstTimeLauncherElement.click();
    } else {
      const iframe = $('.intercom-launcher-frame')[0];
      const iframeDocument =
        iframe.contentDocument || iframe.contentWindow.document;
      const targetElement = $(iframeDocument).find('.intercom-launcher');
      targetElement.click();
    }
  }

  render() {
    // 全タスク達成済後に初めてホーム画面を訪問した際、全タスク達成済み演出を表示する
    if (
      $('.task:input:checkbox').length > 0 &&
      $('.task:input:checkbox').length ==
        $('.task:input:checkbox:checked').length
    ) {
      this.confetti_perform();
    }
  }
}
